let searchBarStyle = {
    search : {
        marginTop: '16px'
    },
    searchBarInput: {
        backgroundColor: '#fafafa',
        height: '30px',
        border: '0.5px solid #dbdbdb',
        borderRadius: '5px',
    },
    searchIcon: {
        width: '14px',
        height: '14px'
    }
}

export default searchBarStyle;